"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeVatBreakdown = computeVatBreakdown;
const cents_1 = require("../money/cents");
const errors_1 = require("../errors");
// La ventilation est une simple agrégation des parts déjà exactes portées par
// les lignes et les frais de livraison : Σ ttc === Σ shares par construction.
// Aucune correction a posteriori du dernier taux (contrairement à la v1, R3).
function computeVatBreakdown(shares) {
    const buckets = new Map();
    for (const share of shares) {
        const bucket = buckets.get(share.tax.id);
        if (bucket) {
            // Un même id de taxe doit porter un taux stable — un taux différent
            // sous le même id est une incohérence d'entrée, pas un cas à absorber
            // silencieusement.
            if (bucket.tax.ratePercent !== share.tax.ratePercent) {
                throw new errors_1.TaxMismatchError(`computeVatBreakdown : taux incohérent pour la taxe ${share.tax.id} (${bucket.tax.ratePercent} vs ${share.tax.ratePercent})`);
            }
            bucket.ttc += share.amount;
        }
        else {
            buckets.set(share.tax.id, { tax: share.tax, ttc: share.amount });
        }
    }
    return [...buckets.values()]
        .sort((a, b) => b.tax.ratePercent - a.tax.ratePercent || a.tax.id.localeCompare(b.tax.id))
        .map(({ tax, ttc }) => ({
        tax,
        ttc,
        ht: (0, cents_1.htFromTtc)(ttc, tax.ratePercent),
        vat: (0, cents_1.vatFromTtc)(ttc, tax.ratePercent),
    }));
}
